<template>
  <span>
     <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          outlined 
          class="primary--text"
          v-bind="attrs"
          v-on="on"
          @input="selectOperation"
        >
         <v-icon small class="mr-1">settings</v-icon>
          Operations
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in filteredItems"
          :key="index"
          @click="selectOperation(item)"
        >
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-if="device" v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{this.selected.text}}</span>
        </v-card-title>
        <v-card-text>
          Are you sure want to  <strong>{{ this.selected.text }}</strong> edge device
          <strong>{{ device.name }}</strong
          >?
          <br/>
            <!-- Change log flow-->
            <div v-if="isLogLevelAction(this.selected.action)">
              <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text class="primary--text mt-4 mb-4"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon class="mr-1">settings</v-icon>
                  LogLevel
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in logLevels"
                  :key="index"
                  @click="selectLogLevel(item)"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
              </v-menu>
              {{ this.selectedLogLevel}}
            </div>
            <!-- Move project flow-->
            <div v-if="isTransferDevice(this.selected.action)">
              <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text class="primary--text mt-4 mb-4"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon class="mr-1">settings</v-icon>
                  Destination project
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in transferProjects()"
                  :key="index"
                  @click="selectTransferDeviceProject(item)"
                >
                  <v-list-item-title>{{ item.project.name }} - {{ item.project.id }}</v-list-item-title>
                </v-list-item>
              </v-list>
              </v-menu>
              <div v-if="this.selectedTransferDeviceProject"
                  text class="primary--text"
              >
                Destination project: {{ this.selectedTransferDeviceProject.name}}
                <ul text class="text--lighten-2">
                  <li>For transfer to work user must have 'Project Administrator' role in the destination project</li>
                  <li>Device will be removed from current project</li>
                  <li>Device will be added to destination project</li>
                  <li>Device restart is needed to SSH to work</li>
                  <li>All applications will be re-scheduled based on new project</li>
                </ul>

              </div>
            </div>

          <p>
            This action might trigger irreversible behavior.            
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn class="secondary--text" small text @click.native="dialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn class="primary" small text @click.native="selected.func()"
            >{{this.selected.text}}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>

export default {
  data() {
    return {
      dialog: false,
      items:[
        {
          text: "Reboot device",
          action: "restart",
          func: this.rebootDevice,
          id: 1,
        },{
          text: "Wipe state",
          action: "wipe",
          func: this.wipeDevice,
          id: 2
        },
        {
          text: "Change log level",
          action: "LogLevel",
          func: this.changeLogLevel,
          id: 3
        },
        {
          text: "Transfer device",
          action: "TransferDevice",
          func: this.transferDevice,
          id: 4
        },
        {
          text: "Disable updates",
          action: "DisableUpdates",
          func: this.disableUpdates,
          id: 5
        },
        {
          text: "Resume updates",
          action: "ResumeUpdates", 
          func: this.resumeUpdates,
          id: 6
        }
      ],
      logLevels: [
       "info",
       "debug",
      ],
      selected: "",
      selectedLogLevel: "",
      selectedTransferDeviceProject: ""
    }
  },
  props: {
    device: Object
  },

  computed: {
    error() {
      return this.$store.state.application.error
    },
    projectId() {
      return this.$route.params.project
    },
    projects() {
      return this.$store.state.project.memberships
    },
    selectedNamespaceId() {
      return this.$route.params.namespace
    },
    currentLogLevel(){
      return this.device.info.agentLogLevel
    },
    filteredItems() {
      let availableItems = [...this.items]
      
      if (this.device && this.device.info) {
        const updatesDisabled = this.device.info.deviceUpdatesDisabled
        
        if (updatesDisabled) {
          // If updates are disabled, hide "Disable updates" and show "Resume updates"
          availableItems = availableItems.filter(item => item.action !== 'DisableUpdates')
        } else {
          // If updates are enabled, hide "Resume updates" and show "Disable updates"
          availableItems = availableItems.filter(item => item.action !== 'ResumeUpdates')
        }
      }
      
      return availableItems
    }
  },

  methods: {
    transferProjects() {
      let projects = this.$store.state.project.memberships
      for (let i = 0; i < projects.length; i++) {
        if (projects[i].project.id == this.projectId) {
          projects.splice(i, 1)
        }
      }
      
      return projects
    },
    rebootDevice() {
      this.$store.dispatch('RebootDevice', this.device).then(() => {
        if (this.error == null) {
          this.dialog = false
        }
      })
    },
    wipeDevice() {
      this.$store.dispatch('WipeDevice', this.device).then(() => {
        if (this.error == null) {
          this.dialog = false
        }
      })
    },
    changeLogLevel() {
      this.device.logLevel = this.selectedLogLevel
      this.$store.dispatch('UpdateDevice', this.device).then(() => {
        if (this.error == null) {
          this.dialog = false
        }
      })
    },
    transferDevice() {
      this.device.logLevel = this.selectedLogLevel
      this.$store.dispatch('TransferDevice',
      {
        id: this.device.id,
        projectID: this.projectId,
        oldProjectId: this.projectId,
        newProjectId: this.selectedTransferDeviceProject.id,
      }).then(() => {
        if (this.error == null) {
          this.dialog = false
        }
      })
    },
    disableUpdates() {
      this.$store.dispatch('DisableDeviceUpdates', this.device).then(() => {
        if (this.error == null) {
          this.dialog = false
          // Refresh device data to show updated status
          this.$emit('refresh-device')
        }
      })
    },
    resumeUpdates() {
      this.$store.dispatch('ResumeDeviceUpdates', this.device).then(() => {
        if (this.error == null) {
          this.dialog = false
          // Refresh device data to show updated status
          this.$emit('refresh-device')
        }
      })
    },
    selectOperation(event) {
      this.selected = event
      this.selectedLogLevel = this.currentLogLevel
      this.dialog=true
    },
    selectLogLevel(event) {
      this.selectedLogLevel = event
    },
    selectTransferDeviceProject(event) {
      this.selectedTransferDeviceProject = event.project
    },
    isLogLevelAction(action){
      return action == 'LogLevel'
    },
    isTransferDevice(action){
      return action == 'TransferDevice'
    }
  }

}
</script>
